module.exports = __webpack_public_path__ + "static/media/Real-Time Tracking.998da5c4.webp";